<template>
  <div class="contact-main-block w-100 relative" @keydown="keyDownEvent">
    <HeaderMenu
      :title="title"
      :routeBackName="routeBackName"
      :class="{ 'mrg-b-30': !$store.state.hasInternet }"
    />

    <div v-if="$store.state.hasInternet">
      <div class="contact-container b-border">
        <div class="colum1">
          <div class="row" v-remove.offline>
            <span class="  text-black">
              {{ $t("userContactDetails.nameAndLastname") }}
            </span>
            <input
              class="input-b-border input-data filled"
              type="text"
              v-bind:value="nameAndLastName"
              @input="setNameAndLastNameDetail($event.target.value)"
            />
          </div>
          <div class="row">
            <span class="  text-black">
              {{ $t("userContactDetails.phone") }}
            </span>
            <input
              class="input-b-border input-data filled"
              type="tel"
              v-bind:value="phoneNumber"
              @input="setPhoneNumberDetail($event.target.value)"
            />
          </div>
        </div>
        <div class="colum1">
          <div class="row" v-remove.offline>
            <span class="  text-black">
              {{ $t("userContactDetails.institutesName") }}
            </span>
            <input
              class="input-b-border input-data filled"
              type="text"
              v-bind:value="institutesName"
              @input="setInstitutesNameDetail($event.target.value)"
            />
          </div>
          <div class="row">
            <span v-if="appMode.offline()" class="  text-black">
              {{ $t("userContactDetails.email") }}
            </span>
            <span v-else class="  text-black">
              {{ $t("userContactDetails.emailRequired") }}
            </span>
            <input
              autocomplete="email"
              class="input-b-border input-data filled"
              type="email"
              v-bind:value="emailAddress"
              @input="setEmailAddressDetail($event.target.value)"
            />
          </div>
        </div>
      </div>

      <div class="text-area-container">
        <textarea
          ref="contentArea"
          class="inputs-data-bloke font h"
          :placeholder="$t('userContactDetails.commentsPlaceholder')"
          @input="setCommentsTextArea"
        ></textarea>
        <p>{{ $t("userContactDetails.requiredFields") }}</p>
      </div>
      <div class="send-block">
        <div class="flex-r">
          <div v-for="error in errors" :key="error" class="email-error">
            {{ error }}
          </div>
        </div>
        <button class="btn send-email font" @click="sendEmail">
          {{ $t("userContactDetails.send") }}
        </button>
      </div>
    </div>
    <div class="company-details-block">
      <div class="company-location-block">
        <div>
          <span class="icon-item icon-location">9</span>
        </div>
        <div class="company-location">
          <p>{{ $t("contactUs.companyAddress") }}</p>
          <p>{{ $t("contactUs.companyPO") }}</p>
          <p>{{ $t("contactUs.companyLocation") }}</p>
          <p>{{ $t("contactUs.companyCountry") }}</p>
        </div>
      </div>
      <div class="company-contant-block">
        <div>
          <span class="icon-item icon-contant">1</span>
        </div>
        <div class="company-contant">
          <p>{{ $t("contactUs.companyPhone") }}</p>
          <p>{{ $t("contactUs.companyFax") }}</p>
          <p>{{ $t("contactUs.companyEmail") }}</p>
          <p v-if="appMode.online()">
            {{ $t("contactUs.compantWhatsApp") }}
            <span style="padding-left:10px">
              <Icons icon="whatsapp" height="12px" width="12px" />
            </span>
            <a target="_blank" href="https://wa.me/97225712713">
              +972-2 5712-713
            </a>
          </p>
        </div>
      </div>
      <div class="company-activity-block">
        <div>
          <span class="icon-item icon-activity">2</span>
        </div>
        <div class="company-activity">
          <p>{{ $t("contactUs.activityTime") }}</p>
          <p>{{ $t("contactUs.activityTimeNote1") }}</p>
          <p>{{ $t("contactUs.activityTimeNote2") }}</p>
        </div>
      </div>
    </div>
    <div v-remove.offline class="go-to-company-staff-block">
      <p>{{ $t("contactUs.goToCompanyStaffDetails") }}</p>
      <button
        class="btn go-to-comp-staff-btn center-y"
        @click="goToCompanyStaffDetails"
      >
        {{ $t("contactUs.clickHere") }}
      </button>
    </div>
  </div>
</template>

<script>
import menuService from "../../../../services/menu";
import * as userSendEmail from "@/services/userSendEmail.js";
import { mapGetters } from "vuex";
import Icons from "@/components/Icons/Icons.vue";

export default {
  data() {
    return {
      title: this.$t("mainMenu.contactName"),
      routeBackName: "main",
      phoneNumber: "",
      nameAndLastName: "",
      institutesName: "",
      emailAddress: "",
      userCommentsDetails: "",
      fieldError: false,
      clientId: 0,
      stickerId: 0,
      errors: [],
    };
  },
  components: { Icons },
  computed: {
    ...mapGetters("user", ["getUserContactDeatils"]),
  },
  methods: {
    keyDownEvent(e) {
      switch (e.code) {
        case "Tab":
          e.cancelBubble = true;
      }
    },
    setPhoneNumberDetail(e) {
      this.errors = [];
      this.phoneNumber = e;
    },
    setNameAndLastNameDetail(e) {
      this.errors = [];
      this.nameAndLastName = e;
    },
    setInstitutesNameDetail(e) {
      this.errors = [];
      this.institutesName = e;
    },
    setEmailAddressDetail(e) {
      this.errors = [];
      this.emailAddress = e;
    },
    setCommentsTextArea(e) {
      this.errors = [];
      this.userCommentsDetails = this.$refs.contentArea.value;
    },
    async sendEmail() {
      //validation
      this.errors = [];
      var val = this.phoneNumber;

      var regExp = /[a-zA-Zא-ת]/g;

      if (val.match(regExp))
        this.errors.push(this.$t("userContactDetails.phoneError"));

      if (
        this.nameAndLastName == "" ||
        this.userCommentsDetails == "" ||
        val == "" ||
        (globalThis.SERVER_MODE == "online" && this.emailAddress == "")
      )
        this.errors.push(this.$t("userContactDetails.requiredError"));

      if (this.errors.length > 0) return;

      let content =
        this.$t("userContactDetails.clientName") +
        ": " +
        this.nameAndLastName +
        "\n" +
        " ";
      if (this.stickerId) {
        content += "מספר מדבקה: " + this.stickerId + "\n\n";
      }
      if (this.clientId) {
        content += "מספר לקוח בתוכנת הלקוחות: " + this.clientId + "\n\n";
      }
      if (globalThis.SERVER_MODE == "online") {
        content += "שם משתמש: " + this.$store.state.user.username + "\n\n";
      }

      content +=
        this.$t("staffContactDetails.phone") + this.phoneNumber + "\n\n";
      if (this.emailAddress) {
        content += this.emailAddress + "\n\n";
      }
      content += this.userCommentsDetails;

      let type = "CONTACT";
      let contactDetails = {
        content,
        type,
      };
      let message = "";
      let messtype = "";
      if (await userSendEmail.postUserSendSystemEmail(contactDetails)) {
        message = this.$t("general.sendSuccess");
        messtype = "success";
      } else {
        message = this.$t("general.sendError");
        messtype = "error";
      }
      const notification = {
        type: messtype,
        message,
        timeout: 2000,
      };
      this.$notify(notification);
      menuService.closeMenu();
    },
    goToCompanyStaffDetails() {
      // this.$router.push({ name: "staff-contact" });
      menuService.openContactListMenu();
    },
  },
  created() {
    if (this.appMode.offline()) {
      this.nameAndLastName = this.$store.state.user.fullname;
      this.clientId = this.$store.state.user.clientId;
      this.stickerId = this.$store.state.user.stickerId;
      this.phoneNumber =
        this.getUserContactDeatils.cellPhone ||
        this.getUserContactDeatils.phone ||
        "";
      this.emailAddress = this.getUserContactDeatils.email || "";
    } else {
      if (this.$store.state.user.userType != "GUEST") {
        this.nameAndLastName = this.$store.state.user.fullname;
        this.clientId = this.$store.state.user.clientId;
        this.stickerId = this.$store.state.user.userId;
        this.phoneNumber =
          this.getUserContactDeatils.cellPhone ||
          this.getUserContactDeatils.phone ||
          "";
        this.emailAddress = this.getUserContactDeatils.email || "";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
$bg-color2: #f7f7f7;
$bg-color5: #f4f4f4;
.colum1 {
  .row {
    margin-bottom: 12px;
  }
}
.contact-main-block {
  // overflow-y: scroll;
  // overflow-x: hidden;
}
.go-to-company-staff-block {
  display: flex;
  margin-top: auto;
  height: 60px;
  background-color: $bg-color5;
  border-top: 1px solid #dedede;
  height: 60px;
  background-color: $bg-color5;
  border: 1px solid #dedede;
  padding: 0 20px;
  position: absolute;
  width: 100%;
  bottom: 0;
  justify-content: space-between;
  p {
    margin: 0;
    line-height: 60px;
    font-weight: bold;
  }
}
.go-to-comp-staff-btn {
  width: auto;
  padding: 0 10px;
  // margin: 3px 0;
  // margin-right: auto;
}
.company-details-block {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .company-location-block {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 30px;
    padding-right: 20px;
    .company-location {
      display: flex;
      flex-direction: column;
      line-height: 0px;
      p {
        margin: 0;
        line-height: 18px;
        font-size: 13px;
      }
    }
    .icon-location {
      display: flex;
      font-size: 100px;
      margin-top: 8px;
      width: 50px;
      opacity: 0.5;
    }
  }
  .company-activity-block {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 30px;
    padding-right: 20px;
    .icon-activity {
      display: flex;
      font-size: 100px;
      margin-top: 8px;
      width: 50px;
      opacity: 0.5;
    }
    .company-activity {
      display: flex;
      flex-direction: column;
      line-height: 0px;
    }
    p {
      margin: 0;
      line-height: 18px;
      font-size: 13px;
    }
  }
  .company-contant-block {
    display: flex;
    justify-content: flex-start;
    padding-right: 20px;
    margin-bottom: 30px;
    .icon-contant {
      display: flex;
      font-size: 100px;
      margin-top: 8px;
      width: 50px;
      opacity: 0.5;
    }
    .company-contant {
      display: flex;
      flex-direction: column;
      line-height: 0px;
    }
    p {
      margin: 0;
      line-height: 18px;
      font-size: 13px;
    }
  }
}
.email-error {
  color: red;
  padding: 0 20px;
}

.contact-container {
  display: flex;
  padding: 0px 10px 0px 10px;
  overflow: auto;
  box-sizing: border-box;
  width: 100%;
  padding: 34px 20px 0px;
  input.input-border.filled + span {
    margin-bottom: 20px !important;
  }
  input.input-border.filled + span span {
    height: 14px;
    line-height: 14px;
    font-size: 10px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.3);
  }
  .input-border.filled:focus + span span {
    color: var(--custom-color1);
  }
}
.input-data {
  width: 90%;
  display: flex;
  border: none;
  //margin: 0px 4px 0px 0px;
  border-bottom: 1px solid #afafaf;
  background: none;
  padding: 0;
  margin-left: 18px;
  //width: -webkit-fill-available;
}

.send-block {
  display: flex;
  justify-content: space-between;
  margin: 0 6px;
}
.send-email {
  margin-right: auto;
  margin-left: 20px;
}
.text-area-container {
  padding: 0 20px 0;
  p {
    margin: 0;
    font-weight: 300;
    color: var(--custom-color1);
    font-size: 12px;
    padding-bottom: 10px;
    font-weight: bold;
  }
  .inputs-data-bloke {
    resize: none;
    width: 97%;
    height: 150px;
    // margin: 6px;
    line-height: 20px;
    background-color: $bg-color2;
    // margin-top: 3px;
    border: 1px solid #afafaf;
    margin-bottom: 3px;
    &::placeholder {
      color: var(--text-color3) !important;
    }
  }
}
</style>
